import {isEmpty} from "lodash";
import {PersonalAnalyticInfo} from "../store/portal/portal.model";

export const parsePersonalAnalyticInfo = (payload: string): PersonalAnalyticInfo | null => {
  if (isEmpty(payload)) {
    return null;
  }
  try {
    return JSON.parse(payload);
  } catch (_) {
    return null;
  }
};
